import React from 'react';

function Card({ children, className = '', ...props }) {
  return (
    <div className={`rounded-xl border border-[var(--axial-border)] bg-[var(--axial-surface-elevated)] p-4 shadow-sm ${className}`} {...props}>
      {children}
    </div>
  );
}

export default Card;
